import * as React from "react"
import { useTranslation } from "react-i18next"

export default function Footer() {
  const { t } = useTranslation()
  
  return (<p className="small">{t("results.footer")}</p>)
}